module.exports = __webpack_public_path__ + "img/Polygrafin_AT_010.403b4dcc.jpg";